/**
 * The read-only optional-field row list shared by every profile view
 * (issue #508's anti-fork, #497). A definition list of `{ label, value }`
 * rows: two columns at `sm` in the full variant, a single column when
 * `compact` (the inline-under-a-name variant). It renders NOTHING when
 * there are no rows, so a caller that filtered every empty field down to an
 * empty array leaves no blank card behind — the #292 non-oracle rule that
 * `CoachProfileView` and `PlayerProfileView` both depend on.
 *
 * WHY IT IS ITS OWN COMPONENT: `CoachProfileView` and `PlayerProfileView`
 * render the identical row rhythm. Before #508 the coach view carried this
 * inline; extracting it means the coming single-profile unification
 * (#508's LATER direction) collapses one row list, not two that drifted.
 * The callers keep ownership of WHICH fields are rows and how each value is
 * formatted — this component owns only the rhythm.
 */
export default function ProfileFieldList({ facts, compact = false, testId }) {
  if (!facts || facts.length === 0) return null;
  return (
    <dl
      className={`grid gap-x-4 gap-y-1.5 ${compact ? "" : "sm:grid-cols-2"}`}
      data-testid={testId}
    >
      {facts.map((f) => (
        <div key={f.label} className="min-w-0">
          <dt className="text-[10px] uppercase tracking-wider text-slate-500">{f.label}</dt>
          <dd className="text-sm text-slate-800 break-words">{f.value}</dd>
        </div>
      ))}
    </dl>
  );
}
